<template>
  <div class="pricing-page">
    <!-- 导航栏 -->
    <nav class="nav-bar">
      <div class="logo">
        <span class="logo-symbol"><img src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服"/></span>
        <span class="logo-text">小晖AI客服平台</span>
      </div>
      <div class="nav-links">
        <a href="/solutions">行业解决方案</a>
        <a href="/product-intro">产品介绍</a>
        <a href="/pricing" class="active">定价策略</a>
        <a href="#">技术博客</a>
        <a href="#">关于我们</a>
        <a href="/login" class="secondary-btn">登录</a>
      </div>
    </nav>
    
    <!-- 网站建设中标识 -->
    <div class="construction-banner">
      <div class="construction-content">
        <span class="construction-icon">🚧</span>
        <span class="construction-text">网站建设中，敬请期待</span>
      </div>
    </div>

    <!-- 页面主要内容 -->
    <main class="main-content">
      <!-- 页面标题 -->
      <section class="page-header">
        <h1>定价策略</h1>
        <p class="subtitle">透明、灵活的定价方案，满足不同规模企业的需求</p>
      </section>

      <!-- 目标客户群体 -->
      <section class="target-customers">
        <h2><span class="icon">🎯</span> 我们的目标客户</h2>
        <div class="customers-intro">
          <p>小晖AI客服平台致力于为国内中小企业、小微实体提供低成本、低技术门槛的一站式AI客服解决方案，助力企业轻松实现客户服务的智能化升级。</p>
        </div>
        
        <div class="customer-cards">
          <div class="customer-card">
            <div class="customer-icon">💻</div>
            <h3>个人开发者/自由职业者</h3>
            <p>拥有个人作品集网站、独立开发的App或小程序。需要处理用户咨询但无力承担人工客服时间成本。追求性价比。</p>
          </div>
          
          <div class="customer-card">
            <div class="customer-icon">🏢</div>
            <h3>小微企业与初创公司</h3>
            <p>员工数在1-10人。刚成立或处于早期阶段，官网是主要获客渠道。咨询量有一定波动，希望7x24小时即时响应。</p>
          </div>
          
          <div class="customer-card">
            <div class="customer-icon">🏪</div>
            <h3>实体小店与工作室</h3>
            <p>如咖啡店、瑜伽馆、独立设计师工作室、理发店等。拥有线上预约小程序或简单的宣传页面。需要自动回答价格、营业时间、预约规则等高频问题。</p>
          </div>
          
          <div class="customer-card">
            <div class="customer-icon">🎓</div>
            <h3>知识付费与教育工作者</h3>
            <p>如独立讲师、小型的在线教育平台。需要为学员解答关于课程大纲、学习资料、价格优惠等常见问题。</p>
          </div>
        </div>
      </section>

      <!-- 套餐对比 -->
      <section class="plans-section">
        <h2><span class="icon">📦</span> 套餐对比</h2>
        <p class="section-subtitle">选择适合您业务规模的套餐，享受专属AI客服服务</p>
        
        <div class="plans-table-wrapper">
          <table class="plans-table">
            <thead>
              <tr>
                <th class="feature-header">功能与资源</th>
                <th class="plan-header">
                  <div class="plan-name">试用版</div>
                  <div class="plan-price">¥0<span class="period">/月</span></div>
                  <a href="/register" class="plan-btn">免费试用</a>
                </th>
                <th class="plan-header">
                  <div class="plan-name">基础版</div>
                  <div class="plan-price">¥88<span class="period">/月</span></div>
                  <a href="/register" class="plan-btn">立即购买</a>
                </th>
                <th class="plan-header">
                  <div class="plan-name">团队版</div>
                  <div class="plan-price">¥188<span class="period">/月</span></div>
                  <a href="/register" class="plan-btn">立即购买</a>
                </th>
                <th class="plan-header">
                  <div class="plan-name">企业版</div>
                  <div class="plan-price">¥888<span class="period">/月</span></div>
                  <a href="/register" class="plan-btn">立即购买</a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="category-row">
                <td colspan="5">套餐特色</td>
              </tr>
              <tr>
                <td>目标客户</td>
                <td>新用户</td>
                <td>个体经营者、个人开发者</td>
                <td>中小团队</td>
                <td>有一定规模的企业</td>
              </tr>  
<tr>
                <td>核心价值</td>
                <td>体验功能、感知额度</td>
                <td>低成本获得 AI 客服基础能力</td>
                <td>多人协作的效率与一致性</td>
                <td>治理、合规与风险控制</td>
              </tr>                            
              <tr class="category-row">
                <td colspan="5">核心资源</td>
              </tr>
              <tr>
                <td>月度对话量</td>
                <td>500次</td>
                <td>1,000次</td>
                <td>3,000次</td>
                <td>10,000次</td>
              </tr>
              <tr>
                <td>AI客服中心</td>
                <td>1个</td>
                <td>1个</td>
                <td>3个</td>
                <td>6个</td>
              </tr>
              <tr>
                <td>客服席位</td>
                <td>1个</td>
                <td>3个</td>
                <td>6个</td>
                <td>10个</td>
              </tr>
              
              <tr class="category-row">
                <td colspan="5">知识库管理</td>
              </tr>
              <tr>
                <td>知识库文件上传数量</td>
                <td>5个</td>
                <td>20个</td>
                <td>50个</td>
                <td>200个</td>
              </tr>
              <tr>
                <td>知识库目录</td>
                <td><span class="feature-no">✗</span></td>
                <td><span class="feature-no">✗</span></td>
                <td><span class="feature-yes">✓</span></td>
                <td><span class="feature-yes">✓</span></td>
              </tr>
              
              <tr class="category-row">
                <td colspan="5">图片功能</td>
              </tr>
              <tr>
                <td>图片库图片上传数量</td>
                <td>0</td>
                <td>0</td>
                <td>100个</td>
                <td>400个</td>
              </tr>
              <tr>
                <td>图片库容量</td>
                <td>0</td>
                <td>0</td>
                <td>200MB</td>
                <td>800MB</td>
              </tr>
              <tr>
                <td>图片识别</td>
                <td><span class="feature-no">✗</span></td>
                <td><span class="feature-yes">✓</span></td>
                <td><span class="feature-yes">✓</span></td>
                <td><span class="feature-yes">✓</span></td>
              </tr>
              <tr>
                <td>月图片识别上限</td>
                <td>0</td>
                <td>100个</td>
                <td>300个</td>
                <td>1800个</td>
              </tr>
              <tr>
                <td>AI客服图文并茂回复</td>
                <td><span class="feature-no">✗</span></td>
                <td><span class="feature-no">✗</span></td>
                <td><span class="feature-yes">✓</span></td>
                <td><span class="feature-yes">✓</span></td>
              </tr>
              
              <tr class="category-row">
                <td colspan="5">AI能力与分析</td>
              </tr>
              <tr>
                <td>知识库额度</td>
                <td>10点</td>
                <td>20点</td>
                <td>50点</td>
                <td>200点</td>
              </tr>
              <tr>
                <td>AI 分析对话数（情感分析+意图分析）</td>
                <td>前30条/月</td>
                <td>前100条/月</td>
                <td>前500条/月</td>
                <td>所有对话</td>
              </tr>              
              <tr class="category-row">
                <td colspan="5">团队与部署</td>
              </tr>
              <tr>
                <td>团队管理角色</td>
                <td>系统管理员</td>
                <td>系统管理员+知识库管理员</td>
                <td>系统管理员+知识库管理员+企业管理者</td>
                <td>系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</td>
              </tr>
              <tr>
                <td>部署环境</td>
                <td>低配共享资源池</td>
                <td>中配共享资源池</td>
                <td>高配共享资源池</td>
                <td>高配共享资源池 或 自备专有服务器</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="table-note">
          <p>💡 <strong>备注</strong>：试用版提供长达一年的免费试用期，基础版及更高版本的用户可享受更全面的功能和服务。</p>
        </div>
      </section>

      <!-- 加油包 -->
      <section class="fuel-packages">
        <h2><span class="icon">⛽</span> 加油包</h2>
        <div class="packages-intro">
          <p>加油包是对套餐的有效补充。当用户的月度对话量即将用完时，可以通过无缝续费的"加油包"避免服务中断。加油包只能供购买者使用，不能与其他用户共享。一旦购买，不能退费。</p>
        </div>
        
        <div class="packages-grid">
          <div class="package-card">
            <div class="package-header">
              <h3>小微包</h3>
              <div class="package-price">¥10</div>
            </div>
            <div class="package-content">
              <div class="package-feature">
                <span class="feature-label">包含对话量：</span>
                <span class="feature-value">100次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">单价：</span>
                <span class="feature-value">¥0.1/次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">有效期：</span>
                <span class="feature-value">自购买之日起30天内有效</span>
              </div>
            </div>
            <a href="/register" class="package-btn">立即购买</a>
          </div>
          
          <div class="package-card featured">
            <div class="package-badge">更划算</div>
            <div class="package-header">
              <h3>流量包</h3>
              <div class="package-price">¥68</div>
            </div>
            <div class="package-content">
              <div class="package-feature">
                <span class="feature-label">包含对话量：</span>
                <span class="feature-value">900次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">单价：</span>
                <span class="feature-value">约¥0.075/次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">有效期：</span>
                <span class="feature-value">自购买之日起30天内有效</span>
              </div>
            </div>
            <a href="/register" class="package-btn">立即购买</a>
          </div>
          
          <div class="package-card">
            <div class="package-header">
              <h3>企业包</h3>
              <div class="package-price">¥188</div>
            </div>
            <div class="package-content">
              <div class="package-feature">
                <span class="feature-label">包含对话量：</span>
                <span class="feature-value">2,800次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">单价：</span>
                <span class="feature-value">约¥0.067/次</span>
              </div>
              <div class="package-feature">
                <span class="feature-label">有效期：</span>
                <span class="feature-value">自购买之日起30天内有效</span>
              </div>
            </div>
            <a href="/register" class="package-btn">立即购买</a>
          </div>
        </div>
      </section>

      <!-- FAQ区域 -->
      <section class="faq-section">
        <h2><span class="icon">❓</span> 常见问题</h2>
        
        <div class="faq-list">
          <div class="faq-item">
            <h3>试用版可以使用多久？</h3>
            <p>我们提供长达一年的免费试用期，让您充分体验平台功能。试用版包含基础知识库功能和每月100次对话。</p>
          </div>
          
          <div class="faq-item">
            <h3>如何升级或降级套餐？</h3>
            <p>您可以在账户的"账单管理"页面自助操作。升级套餐即时生效，降级套餐从下一个计费周期开始生效。</p>
          </div>
          
          <div class="faq-item">
            <h3>对话量用完后会怎样？</h3>
            <p>当月度对话量用完后，您可以购买加油包来继续服务，或者等到下个计费周期自动重置。</p>
          </div>
          
          <div class="faq-item">
            <h3>可以开具发票吗？</h3>
            <p>可以。购买套餐和加油呗的的用户登录后，可以在申请开具发票，具体流程请在购买后联系客服。</p>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="cta-content">
          <h3>开始您的AI客服之旅</h3>
          <p>选择合适的套餐，10分钟快速部署，享受7x24小时智能客服服务</p>
          <div class="cta-buttons">
            <a href="/register" class="primary-btn">免费试用一年</a>
            <a href="/chat" class="secondary-btn">在线咨询</a>
          </div>
          <p class="cta-note">小微企业、个体工商户、个人开发者专属优惠方案咨询</p>
        </div>
      </section>
    </main>

    <!-- 备案信息页脚 -->
    <footer class="site-footer">
      <div class="footer-content">
        <p>
          © 2026 北京启明晨晖信息技术有限公司 版权所有
          <br/>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">
            京ICP备2026004802号-1
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PricingPolicy',
  data() {
    return {}
  }
}
</script>

<style scoped>
/* CSS变量定义 */
.pricing-page {
  --space-blue: #0A1A35;
  --tech-blue: #1A4B8C;
  --ai-purple: #00B4FF;
  --electric-blue: #00B4FF;
  --light-bg: #F0F4F9;
  --pure-white: #FFFFFF;
  
  font-family: 'Alibaba PuHuiTi', 'Microsoft YaHei', sans-serif;
  min-height: 100vh;
  background: #ffffff;
}

/* ========== 导航栏样式 ========== */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(10, 26, 53, 0.95);
  backdrop-filter: blur(8px);
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 80px;
  padding: 15px max(20px, env(safe-area-inset-right)) 15px max(20px, env(safe-area-inset-left));
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-text {
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  white-space: nowrap;
}

.nav-links a {
  margin: 0 15px;
  text-decoration: none;
  color: white;
  position: relative;
  font-weight: 500;
  transition: all 0.3s;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-right: 20px;
  flex-wrap: nowrap;
}

.nav-links a:hover {
  color: #00B4FF;
}

.nav-links a:hover::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--ai-purple);
  animation: underline 0.3s forwards;
}

@keyframes underline {
  from { width: 0; }
  to { width: 100%; }
}

.nav-links a.active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #057FDB;
}

.nav-links .secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid #057FDB;
  padding: 8px 20px;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s;
  margin-left: 10px;
  text-decoration: none;
}

.nav-links .secondary-btn:hover {
  background: rgba(5, 127, 219, 0.1);
  transform: translateY(-2px);
}

/* ========== 网站建设条 ========== */
.construction-banner {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  background: #f0f7ff;
  color: #4a6fa5;
  text-align: center;
  padding: 6px 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  border-bottom: 2px solid #d1e3ff;
  box-sizing: border-box;
  z-index: 999;
  box-shadow: 0 3px 3px rgba(207, 189, 184, 0.3);
}

.construction-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ========== 主要内容区域 ========== */
.main-content {
  max-width: 1200px;
  margin: 140px auto 0;
  padding: 0 20px;
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 0;
  border-bottom: 1px solid #eaeaea;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #0A1A35;
  margin-bottom: 15px;
}

.page-header .subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* ========== 目标客户群体 ========== */
.target-customers {
  margin-bottom: 60px;
}

.target-customers h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.customers-intro {
  background: #F0F8FF;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  border-left: 4px solid #057FDB;
}

.customers-intro p {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
  line-height: 1.6;
}

.customer-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.customer-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #e8f0fe;
}

.customer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(5, 127, 219, 0.1);
  border-color: #057FDB;
}

.customer-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.customer-card h3 {
  color: #0A1A35;
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.customer-card p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* ========== 套餐对比 ========== */
.plans-section {
  margin-bottom: 60px;
}

.plans-section h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-subtitle {
  color: #666;
  margin-bottom: 30px;
  font-size: 1.1rem;
}

.plans-table-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.plans-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.plans-table th,
.plans-table td {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.plans-table thead {
  background: linear-gradient(135deg, #0A1A35, #162B50);
  color: white;
}

.plans-table .feature-header {
  text-align: left;
  font-weight: 600;
  background: #f8f9fa;
  color: #0A1A35;
  min-width: 200px;
}

.plans-table .plan-header {
  padding: 20px 16px;
}

.plans-table .plan-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.plans-table .plan-price {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 15px;
}

.plans-table .plan-price .period {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
}

.plans-table .plan-btn {
  display: inline-block;
  background: #057FDB;
  color: white;
  padding: 8px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.plans-table .plan-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
}

.plans-table tbody tr:nth-child(even) {
  background: #f8f9fa;
}

.plans-table tbody tr:hover {
  background: #f0f8ff;
}

.plans-table .category-row {
  background: #e3f2fd !important;
  font-weight: bold;
  color: #0A1A35;
}

.plans-table .category-row td {
  padding: 12px 16px;
  border-bottom: 2px solid #057FDB;
}

.feature-yes {
  color: #2E7D32;
  font-weight: bold;
  font-size: 1.2rem;
}

.feature-no {
  color: #757575;
  font-weight: bold;
  font-size: 1.2rem;
}

.table-note {
  background: #FFF3E0;
  border: 1px solid #FFE0B2;
  border-radius: 8px;
  padding: 15px 20px;
  margin-top: 20px;
}

.table-note p {
  margin: 0;
  color: #E65100;
  font-size: 0.95rem;
}

/* ========== 加油包 ========== */
.fuel-packages {
  margin-bottom: 60px;
}

.fuel-packages h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.packages-intro {
  background: #F0F8FF;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  border-left: 4px solid #057FDB;
}

.packages-intro p {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
  line-height: 1.6;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-top: 20px;
}

.package-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 25px;
  position: relative;
  transition: all 0.3s;
}

.package-card:hover {
  border-color: #057FDB;
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.package-card.featured {
  border-color: #057FDB;
  border-width: 3px;
  box-shadow: 0 10px 30px rgba(5, 127, 219, 0.15);
}

.package-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #057FDB;
  color: white;
  padding: 4px 15px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
}

.package-header {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.package-header h3 {
  color: #0A1A35;
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.package-price {
  color: #057FDB;
  font-size: 2rem;
  font-weight: bold;
}

.package-content {
  margin-bottom: 25px;
}

.package-feature {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
}

.package-feature:last-child {
  border-bottom: none;
}

.feature-label {
  color: #666;
  font-size: 0.95rem;
}

.feature-value {
  color: #0A1A35;
  font-weight: 600;
  font-size: 0.95rem;
}

.package-btn {
  display: block;
  width: 100%;
  background: #057FDB;
  color: white;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.package-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 127, 219, 0.3);
}

/* ========== FAQ区域 ========== */
.faq-section {
  margin-bottom: 60px;
}

.faq-section h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.faq-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  border-left: 4px solid #00B4FF;
  transition: transform 0.3s;
}

.faq-item:hover {
  transform: translateY(-3px);
}

.faq-item h3 {
  color: #0A1A35;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

.faq-item p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* ========== CTA区域 ========== */
.cta-section {
  background: linear-gradient(135deg, #0A1A35, #162B50);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: white;
  margin-top: 40px;
  margin-bottom: 60px;
}

.cta-content h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: white;
}

.cta-content p {
  opacity: 0.9;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.primary-btn {
  background: #057FDB;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.primary-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 127, 219, 0.3);
}

.secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 10px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  font-size: 1rem;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.cta-note {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-top: 20px;
}

/* ========== 页脚 ========== */
.site-footer {
  background: #f5f5f5;
  border-top: 1px solid #eee;
  padding: 30px 5%;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
}

.footer-content p {
  margin: 0;
  line-height: 1.6;
}

.site-footer a {
  color: #666;
  text-decoration: none;
  font-family: 'Courier New', Courier, monospace;
}

.site-footer a:hover {
  color: #1296db;
  text-decoration: underline;
}

/* ========== 响应式设计 ========== */
@media (max-width: 768px) {
  .main-content {
    margin-top: 130px;
    padding: 0 15px;
  }
  
  .page-header {
    padding: 20px 0;
    margin-bottom: 30px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .customer-cards,
  .packages-grid {
    grid-template-columns: 1fr;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .nav-links {
    gap: 10px;
    padding-right: 10px;
  }
  
  .nav-links a {
    font-size: 0.9rem;
  }
  
  .plans-table-wrapper {
    margin-left: -15px;
    margin-right: -15px;
    border-radius: 0;
  }
  
  .plans-table th,
  .plans-table td {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  .plans-table .plan-price {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .nav-bar {
    height: auto;
    padding: 10px;
    flex-wrap: wrap;
  }
  
  .nav-links {
    width: 100%;
    justify-content: center;
    margin-top: 10px;
    padding-right: 0;
  }
  
  .construction-banner {
    top: 120px;
  }
  
  .main-content {
    margin-top: 160px;
  }
  
  .plans-table th,
  .plans-table td {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  .plan-btn,
  .package-btn {
    padding: 8px 12px;
    font-size: 0.9rem;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.target-customers,
.plans-section,
.fuel-packages,
.faq-section {
  animation: fadeIn 0.5s ease-out;
}
</style>